module.exports = __webpack_public_path__ + "static/media/caramida-aparenta-klinker-Sao-Paulo.1b5cfcbb.jpg";